import { AppAreaConfig } from '@/funnels/@types'
import taiChiMalePrintable from './activity-male-tai-chi-yoga-pr'

const appAreaConfig: AppAreaConfig = {
	appArea: 'tai-chi-male-golfers-fwf',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-m-golfers', 'age-tai-chi-m-golfers'],
		route: {
			path: '/tai-chi-m-golfers',
			name: 'male-tai-chi-golfers-funnel',
		},
	},
	funnel: {
		id: 'ob-male-tai-chi-golfers-fwf',
		route: {
			path: '/tai-chi-m-golfers/ob/:page*',
			name: 'tai-chi-male-golfers-fwf',
		},
		slug: 'tai-chi-male-golfers-fwf',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: taiChiMalePrintable,
				page: 'physical-build',
			},
		},
	},
}

export default appAreaConfig
